export const ru = {
    maxLibraryLists: 'Вы можете создать до 30 наборов минус-фраз',
    minusPhraseBrackets:
        'Квадратные скобки [] не могут быть пустыми и вложенными, минус-фразы: {subset}',
    minusPhraseBracketsOperator:
        'Неправильный оператор внутри скобок. Ошибка во фразе: {subset}',
    minusPhraseCharts:
        'В минус-фразах разрешается использовать только буквы английского, турецкого, казахского, русского, украинского или белорусского алфавита, кавычки, квадратные скобки, знаки "-", "+", "!", пробел. Ошибки во фразах: {subset}',
    minusPhraseDots:
        'Минус-фразы не могут содержать отдельно стоящие точки: {subset}',
    minusPhraseEmpty: 'Заполните минус-фразы',
    minusPhraseExclamation:
        'Неправильное использование знака "!" в минус-фразах: {subset}',
    minusPhraseFirstChar: 'Ошибка в первом символе. Ошибка во фразе: {subset}',
    minusPhraseInvalidDot:
        'Минус-фразы могут содержать не более двух цифр подряд через точку. Ошибки во фразах: {subset}',
    minusPhraseMax: 'Максимальное количество символов в поле — {count}',
    minusPhraseMaxLengthWordsInMinusPhrase:
        'Слово в минус-фразе не может быть длиннее {count} символов. Ошибки во фразах: {subset}',
    minusPhraseMaxWordsInMinusPhrase:
        'Минус-фраза не может состоять более чем из {count} слов: {subset}',
    minusPhraseMinus:
        'Неправильное расположение минуса. Ошибка во фразе: {subset}',
    minusPhrasePlus:
        'Неправильное расположение плюса. Ошибка во фразе: {subset}',
    minusPhraseQuotes: 'Неправильные ковычки. Ошибка во фразе: {subset}',
    minusPhraseSpecialSymbols:
        'Неправильное расположение специальных символов. Ошибка во фразах: {subset}',
    textError: 'Во время выполнения операции произошла ошибка',
    titleEmpty: 'Название не должно быть пустым',
    titleMax: 'Название набора не может быть длиннее {count} символов',
    titleSymbols: 'Название набора содержит спецсимволы'
};
